/**
 * @description Retrievers the details of a specific historical sync run and sets it to the sync results context
 */

import React from 'react';

import { SetSyncResultsContext } from '@seccon/shared/personnelSyncResults/contexts/SyncResults';
import { ToastContext } from '@seccon/core/contexts/toast';
import decodeJson from '@seccon/shared/utils/decodeJson';

/**
 * @param {number} id - history id to retrieve data on
 */
const useHistoryDetails = (id) => {
  const { error } = React.useContext(ToastContext);
  const [isError, setIsError] = React.useState(false);

  // Callback function to set the sync results context
  const setResults = React.useContext(SetSyncResultsContext);

  /**
   * Handles fetch success by storing the api response
   * @param {object} response - api response
   */
  function handleSuccess (response) {
    setResults(response ?? {});
  }

  /**
   * Handles fetch failure by notifying the user
   */
  function handleFailure ({ status }) {
    let msg = 'Personnel sync results could not be loaded. Refresh the page and try again.';

    if (status === 404) {
      msg = 'Personnel sync results could not be found.';
    }

    setIsError(true);

    error(msg);
  }

  // On mount, fetches the sync history results
  React.useEffect(() => {
    // If the id is not defined, do nothing
    if (!id) {
      return;
    }

    fetch(`/personnelSyncHistory/${ id }`)
      .then(decodeJson)
      .then(handleSuccess)
      .catch(handleFailure);
  }, [id]);

  return isError;
};

export default useHistoryDetails;
